import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleRateSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle opacity={0.88} cx={28} cy={28} r={28} fill="#56A" />
      <rect x={16} y={16} width={24} height={24} rx={1} fill="#8F9DD6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 15.75c.69 0 1.25.56 1.25 1.25v20.75H39a1.25 1.25 0 110 2.5H17c-.69 0-1.25-.56-1.25-1.25V17c0-.69.56-1.25 1.25-1.25z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2 22a.3.3 0 00-.2.51l1.6 1.6-4.44 4.44-3.3-3.15a1.25 1.25 0 00-1.74.02l-4 4a1.25 1.25 0 001.76 1.76l3.14-3.13 3.3 3.15c.48.47 1.26.46 1.74-.02l5.3-5.3 1.6 1.6a.3.3 0 00.52-.2V22.3a.3.3 0 00-.3-.3H32.2z"
        fill="#fff"
      />
    </svg>
  );
}

SvgPicCircleRateSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleRateSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleRateSelected svgRef={ref} {...props} />
));
export default ForwardRef;
